// extracted by mini-css-extract-plugin
export default {"button":"BackToTopButton_button__0AdIw","icon":"BackToTopButton_icon__36pi8"};